import { getENV } from '../../utils/env';
import { BranchConfig } from './types';

export const getBranchConfig = (): BranchConfig => {
    const { NEXT_PUBLIC_BRANCH_KEY, NEXT_PUBLIC_APP_ENV } = getENV();
    const isProd = NEXT_PUBLIC_APP_ENV === 'prod';

    return {
        branchKey: NEXT_PUBLIC_BRANCH_KEY,
        enableJourneys: true,
        debug: !isProd,
        branchScriptUrl: 'https://cdn.branch.io/branch-latest.min.js',
    };
};

export function trackBranchAddToCart(
    eventData: Record<string, unknown>,
    contentItems: Record<string, unknown>[]
): void {
    if (!window.branch?.logEvent) {
        console.warn('Branch SDK logEvent not available');
        return;
    }

    window.branch.logEvent('ADD_TO_CART', eventData, contentItems, err => {
        if (err) {
            console.error('Branch ADD_TO_CART tracking failed:', err);
        }
    });
}

export function trackBranchPurchase(eventData: Record<string, unknown>, contentItems: Record<string, unknown>[]): void {
    if (!window.branch?.logEvent) {
        console.warn('Branch SDK logEvent not available');
        return;
    }

    window.branch.logEvent('PURCHASE', eventData, contentItems, err => {
        if (err) {
            console.error('Branch PURCHASE tracking failed:', err);
        }
    });
}
